var lists_default = {
  "fontElementMap": "X08dS",
  "orderedlist": "nztwc",
  "bulletedlist": "ZfI3M",
  "listItem": "H1oSL"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
